var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2 4.5C2.39782 4.5 2.77936 4.34196 3.06066 4.06066C3.34196 3.77936 3.5 3.39782 3.5 3C3.5 2.60218 3.34196 2.22064 3.06066 1.93934C2.77936 1.65804 2.39782 1.5 2 1.5C1.60218 1.5 1.22064 1.65804 0.93934 1.93934C0.658035 2.22064 0.5 2.60218 0.5 3C0.5 3.39782 0.658035 3.77936 0.93934 4.06066C1.22064 4.34196 1.60218 4.5 2 4.5ZM6 2C5.44688 2 5 2.44687 5 3C5 3.55312 5.44688 4 6 4H15C15.5531 4 16 3.55312 16 3C16 2.44687 15.5531 2 15 2H6ZM6 7C5.44688 7 5 7.44688 5 8C5 8.55312 5.44688 9 6 9H15C15.5531 9 16 8.55312 16 8C16 7.44688 15.5531 7 15 7H6ZM6 12C5.44688 12 5 12.4469 5 13C5 13.5531 5.44688 14 6 14H15C15.5531 14 16 13.5531 16 13C16 12.4469 15.5531 12 15 12H6ZM2 14.5C2.39782 14.5 2.77936 14.342 3.06066 14.0607C3.34196 13.7794 3.5 13.3978 3.5 13C3.5 12.6022 3.34196 12.2206 3.06066 11.9393C2.77936 11.658 2.39782 11.5 2 11.5C1.60218 11.5 1.22064 11.658 0.93934 11.9393C0.658035 12.2206 0.5 12.6022 0.5 13C0.5 13.3978 0.658035 13.7794 0.93934 14.0607C1.22064 14.342 1.60218 14.5 2 14.5ZM3.5 8C3.5 7.80302 3.4612 7.60796 3.38582 7.42597C3.31044 7.24399 3.19995 7.07863 3.06066 6.93934C2.92137 6.80005 2.75601 6.68956 2.57403 6.61418C2.39204 6.5388 2.19698 6.5 2 6.5C1.80302 6.5 1.60796 6.5388 1.42597 6.61418C1.24399 6.68956 1.07863 6.80005 0.93934 6.93934C0.800052 7.07863 0.689563 7.24399 0.614181 7.42597C0.538799 7.60796 0.5 7.80302 0.5 8C0.5 8.19698 0.538799 8.39204 0.614181 8.57403C0.689563 8.75601 0.800052 8.92137 0.93934 9.06066C1.07863 9.19995 1.24399 9.31044 1.42597 9.38582C1.60796 9.4612 1.80302 9.5 2 9.5C2.19698 9.5 2.39204 9.4612 2.57403 9.38582C2.75601 9.31044 2.92137 9.19995 3.06066 9.06066C3.19995 8.92137 3.31044 8.75601 3.38582 8.57403C3.4612 8.39204 3.5 8.19698 3.5 8Z",
          fill: "#A8AEB8",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }